'use client';

import { ThemeProvider } from '@/components/theme-provider';
import { Toaster } from '@/components/ui/toaster';
import { Navbar } from '@/components/navbar';
import { SophonzProvider } from './sophonz-provider';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      <SophonzProvider>
        <Navbar />
        <main className="container mx-auto p-4">
          {children}
          {/* <Analytics /> */}
        </main>
        <Toaster />
      </SophonzProvider>
    </ThemeProvider>
  );
}
